import { useEffect, useState } from "react";
import api from "../lib/api";
import { X, Send } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { showGoldlyReward } from "./GoldlyReward";

export default function CommentsSheet({ reel, onClose }) {
  const [comments, setComments] = useState([]);
  const [text, setText] = useState("");

  const load = () => api.get(`/reels/${reel.id}/comments`).then(r => setComments(r.data));
  useEffect(() => { load(); }, [reel.id]);

  const post = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const { data } = await api.post(`/reels/${reel.id}/comments`, { content: text });
      setText(""); load();
      if (data?.earned > 0) showGoldlyReward(data.earned, "comment");
    } catch {}
  };

  return (
    <AnimatePresence>
      <motion.div className="fixed inset-0 z-[60] max-w-md mx-auto" initial={{opacity:0}} animate={{opacity:1}} exit={{opacity:0}}>
        <div className="absolute inset-0 bg-black/70" onClick={onClose} />
        <motion.div initial={{y:"100%"}} animate={{y:0}} exit={{y:"100%"}} transition={{type:"spring", damping:30}}
          className="absolute bottom-0 inset-x-0 glass rounded-t-3xl h-[75vh] flex flex-col" data-testid="comments-sheet">
          <div className="flex items-center justify-between p-4 border-b border-white/10">
            <h3 className="font-outfit font-bold">Comments • {comments.length}</h3>
            <button onClick={onClose} data-testid="comments-close"><X className="w-6 h-6"/></button>
          </div>
          <div className="flex-1 overflow-y-auto p-4 space-y-3 scrollbar-hide">
            {comments.length === 0 && <p className="text-center text-white/40 py-8">Be the first to comment</p>}
            {comments.map(c => (
              <div key={c.id} className="flex gap-2.5" data-testid={`comment-${c.id}`}>
                <img src={c.avatar} alt="" className="w-9 h-9 rounded-full" />
                <div className="flex-1">
                  <div className="text-xs font-bold text-[#00E5FF]">@{c.username}</div>
                  <div className="text-sm">{c.content}</div>
                </div>
              </div>
            ))}
          </div>
          <form onSubmit={post} className="p-3 border-t border-white/10 flex gap-2 bg-[#0B0F19]" style={{ paddingBottom: "max(env(safe-area-inset-bottom), 12px)" }}>
            <input data-testid="comment-input" value={text} onChange={e=>setText(e.target.value)} placeholder="Add a comment..." className="flex-1 px-4 py-2.5 rounded-full bg-white/5 border border-white/10 outline-none" />
            <button data-testid="comment-send" className="w-11 h-11 rounded-full bg-[#00E5FF] flex items-center justify-center"><Send className="w-5 h-5 text-black"/></button>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
